import React, { useEffect, useState } from 'react';
import { deleteProjectAsset, getProjectAssets } from '../../../api';
import { spinnerOff, spinnerOn } from '../../../components/Spinner';
import { Col, Row, Table, Radio } from 'antd';
import './assettable.css';
import AssetFileExport from './AssetFileExport';
import { confirmAlert } from 'react-confirm-alert';
import {projectStatusCodeMap} from "../../../components/ProjectStatusCodeMap";
import {projectStatusMap} from "../../../components/ProjectStatusMap";
import { Link } from 'react-router-dom';
import AttestationDialog from 'components/AttestationDialog';

function Asset({ project, refreshAssets, setRefreshAssets }) {
  const [assets, setAssets] = useState([]);
  const [assetsAfterTrimmed, setAssetsAfterTrimmed] = useState([]);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [refresh, setRefresh] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [pceAssets, setPceAssets] = useState([]);
  const [stationAssets, setStationAssets] = useState([]);
  const [quickFilterAssets, setQuickFilterAssets] = useState("ALL");
  const [attestAsset,setAttestAsset] = useState();

  useEffect(() => {
    async function getData() {
      let assets = await getProjectAssets(project.id);
      let assetsAfterTrimmed = assets.map(asset => {
        let ipsName = asset.ipsLocationName;
        let stationName = project.stationName;
        let stationNameLength = stationName.length;
        let ipsLocationNameLength = ipsName.indexOf(stationName) + stationNameLength;
        let trimmedIpsLoc = ipsName.substring(ipsLocationNameLength);
        asset.ipsLocationName = trimmedIpsLoc.slice(1);
      });
      setAssets(assets);
      setAssetsAfterTrimmed(assetsAfterTrimmed);
      //if (assets.length === 0) return <h2> There are no assets in the database </h2>;
      setRefresh(false);
      if(setRefreshAssets!=null)setRefreshAssets(false);
    }

    if (refreshAssets || refresh) getData();
  }, [refresh, refreshAssets]);


  useEffect(() => {
      setPceAssets(assets.filter(val => val.checklistRespblty === "P&C"));
      setStationAssets(assets.filter(val => val.checklistRespblty === "STATION"));
  }, [refreshAssets]);

  const handleModalClick = (record) => {
    const recordFound = assets.find(rec => rec.assetId === record);
    setAttestAsset(recordFound);
    setOpenModal(true);
  }

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

   const handleCancel = () => {
     setOpenModal(false);
  };

  const handleAssetSelection = (e) => {
    setQuickFilterAssets(e.target.value);
  }

  function composeFilters(fieldName) {
    let filtersSort = [];
    let filters = [...new Set(assets.map(asset => asset[fieldName]))];
    (fieldName === 'attestationStatus') ? filtersSort = filters.map(distinctFilters => ({ text: distinctFilters === null ? 'Unassigned': distinctFilters, value: distinctFilters }))
   : filtersSort = filters.map(distinctFilters => ({ text: distinctFilters, value: distinctFilters }));
    filtersSort.sort((a, b) => {
      a = a.text || '';
      b = b.text || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    
    return filtersSort;
  }

  function multipleSort(compFunctions) {
    return function(a, b) {
      for (const func of compFunctions) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
    };
  }

  async function removeAsset(assetId) {
    spinnerOn();
    await deleteProjectAsset(assetId);
    spinnerOff();
    setRefresh(true);
  }

  const iPSComp = (a, b) => {
    a = a.ipsLocationName || '';
    b = b.ipsLocationName || '';

    return b.localeCompare(a);
  };
  const assetNameComp = (a, b) => {
    a = a.assetName || '';
    b = b.assetName || '';

    return b.localeCompare(a);
  };

  const columns = [{
    dataIndex: 'assetName',
    width: '15%',
    key: 'assetName',
    title: 'Asset Name',
    fixed: 'left',
    filters: composeFilters('assetName'),
    filteredValue: filteredInfo.assetName || null,
    onFilter: (value, record) => record.assetName === value,
    sorter: (a, b) => {
      a = a.assetName || '';
      b = b.assetName || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'assetName' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  },{
    dataIndex: 'checkListSectionNameNoNull',
    width: '7%',
    key: 'checkListSectionNameNoNull',
    title: 'Section',
    fixed: 'left',
    filters: composeFilters('checkListSectionNameNoNull'),
    filteredValue: filteredInfo.checkListSectionNameNoNull || null,
    onFilter: (value, record) => record.checkListSectionNameNoNull === value,
    sorter: (a, b) => {
      a = a.checkListSectionNameNoNull || '';
      b = b.checkListSectionNameNoNull || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'checkListSectionNameNoNull' && sortedInfo.order,
    render: (text, record) => {
      return (record.deleteFlag === 'P') ? <a href='#' onClick={() => confirmAlert(
        {
          title: 'Remove Asset',
          message: 'This asset is flagged as "Verify IPS Data" because some information in IPS ' +
              'has changed to break the association in the Checklist. Removing the asset from the  ' +
              'Checklist will not effect the IPS Asset itself.',

          childrenElement: () =>
              <div>
                <br/>
                For assistance, please contact your Construction
                Admin or visit the Checklist ShareNow page for documentation.
                <br/>
                <a style={{display: 'flex',  justifyContent:'center', alignItems:'center'}} href="https://sharenow.sp.aepsc.com/transmission/tfs/policies/checklist">
                  https://sharenow.sp.aepsc.com/transmission/tfs/policies/checklist
                </a>
                <br/>
                Are you sure you want remove the following Asset?
                <div>
                <Row style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>Asset Name: {record.assetName}</Row>
                <Row style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>IPS Internal Ref. No.: {record.internalRef}</Row>
                </div>
              </div>,

          buttons: [
            {
              label: 'Yes',
              onClick: async () => {
                await removeAsset(record.assetId);
              }
            },
            {
              label: 'No'
            }
          ]
        }
      )} style={{ color: 'red',textDecoration:'underline'}}>{text}</a> :
          (record.deleteFlag === 'B') ? <b>VERIFY IPS DATA</b> : text;
    }
  }, {
    dataIndex: 'assetGroupName',
    width: '4%',
    key: 'assetGroupName',
    title: 'Asset Group',
    filters: composeFilters('assetGroupName'),
    filteredValue: filteredInfo.assetGroupName || null,
    onFilter: (value, record) => record.assetGroupName === value,
    sorter: (a, b) => {
      a = a.assetGroupName || '';
      b = b.assetGroupName || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'assetGroupName' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  }, {
    dataIndex: 'assetType',
    width: '8%',
    key: 'assetType',
    title: 'Asset Type',
    filters: composeFilters('assetType'),
    filteredValue: filteredInfo.assetType || null,
    onFilter: (value, record) => record.assetType === value,
    sorter: (a, b) => {
      a = a.assetType || '';
      b = b.assetType || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'assetType' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  },  {
    dataIndex: 'ipsLocationName',
    width: '18%',
    key: 'ipsLocationName',
    title: 'IPS Location',
    filters: composeFilters('ipsLocationName'),
    filteredValue: filteredInfo.ipsLocationName || null,
    onFilter: (value, record) => record.ipsLocationName === value,
    sorter: (a, b) => {
      a = a.ipsLocationName || '';
      b = b.ipsLocationName || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'ipsLocationName' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  }, {
    dataIndex: 'formName',
    width: '10%',
    key: 'formName',
    title: 'Pre-E Form',
    filters: composeFilters('formName'),
    filteredValue: filteredInfo.formName || null,
    onFilter: (value, record) => record.formName === value,
    sorter: (a, b) => {
      a = a.formName || '';
      b = b.formName || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'formName' && sortedInfo.order,
    render: (text, record) => {
      return (record.formId > 0) ? <Link to={`/${projectStatusMap[project.projectStatus]}/${project.id}/peform/${record.formId}/showTasks`}>{text}</Link> : text;
    }
  }, {
    dataIndex: 'attestationStatus',
    width: '8%',
    key: 'attestationStatus',
    title: 'Attestation Status',
    filters: composeFilters('attestationStatus'),
    filteredValue: filteredInfo.attestationStatus|| null,
    onFilter: (value, record) => record.attestationStatus === value,
    sorter: (a, b) => {
      a = a.attestationStatus || '';
      b = b.attestationStatus || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'attestationStatus' && sortedInfo.order,
    render: (text, record) => {
      return (record.attestationStatus === "Unassigned" || record.attestationStatus === "No Attestation") ? 
        text
      :( <a href="#" onClick={() => handleModalClick(record.assetId)} style={{ marginLeft: '15px' }}>
       {text}
      </a>);
    }
  }, {
    dataIndex: 'workOrder',
    width: '8%',
    key: 'workOrder',
    title: 'Install WO#',
    filters: composeFilters('workOrder'),
    filteredValue: filteredInfo.workOrder || null,
    onFilter: (value, record) => record.workOrder === value,
    sorter: (a, b) => {
      a = a.workOrder || '';
      b = b.workOrder || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'workOrder' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  }, {
    dataIndex: 'bpid',
    width: '8%',
    key: 'bpid',
    title: 'Install BPID',
    filters: composeFilters('bpid'),
    filteredValue: filteredInfo.bpid || null,
    onFilter: (value, record) => record.bpid === value,
    sorter: (a, b) => {
      a = a.bpid || '';
      b = b.bpid || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'bpid' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  }, {
    dataIndex: 'internalRef',
    width: '10%',
    key: 'internalRef',
    title: 'IPS Internal Ref. No.',
    filters: composeFilters('internalRef'),
    filteredValue: filteredInfo.internalRef || null,
    onFilter: (value, record) => record.internalRef === value,
    sorter: (a, b) => {
      a = a.internalRef || '';
      b = b.internalRef || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'internalRef' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  }, {
    dataIndex: 'assetStatus',
    width: '8%',
    key: 'assetStatus',
    title: 'IPS Asset Status',
    filters: composeFilters('assetStatus'),
    filteredValue: filteredInfo.assetStatus || null,
    onFilter: (value, record) => record.assetStatus === value,
    sorter: (a, b) => {
      a = a.assetStatus || '';
      b = b.assetStatus || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    },
    sortOrder: sortedInfo.columnKey === 'assetStatus' && sortedInfo.order,
    render: (text, record) => {
      return text;
    }
  }];

  return (
    <div className='container-fluid'>
      {/*<b>{this.state.project.stationName}</b>*/}
      <Row xs={24} style={{alignItems: 'center', margin: '8px 0px'}}>
        <Col xs={18}>
        <div className="row asset-task-header" style={{justifyContent: 'center',}}>
          <Radio.Group onChange={handleAssetSelection}
          value={quickFilterAssets}
          style={{display: "flex", flexDirection: "row",justifyContent:'space-between', width:'60%'}}>
            <Radio  id="radio-1"
                    value="ALL">
              ALL
            </Radio>
            <Radio  id="radio-2"
                    value="P&C">
              P&C Assets
            </Radio>
            <Radio  id="radio-3"
                    value="STATION">
              Station Assets
            </Radio>
          </Radio.Group>
        </div>
      </Col>
      </Row>
      <Row xs={24} style={{alignItems: 'center', margin: '8px 0px'}}>
        <Col xs={18}>
          Here are the assets pulled for this project. Please review, and if
          there are any discrepancies, fix in IPS.
        </Col>
        <Col xs={6}>
          <h4>
            <AssetFileExport projectId={project.id} station={project.stationName} />
          </h4>
        </Col>
      </Row>
        <Table
          className={'table-striped'}
          columns={columns.filter(t=>project.projectStatus===projectStatusCodeMap["RELEASE"] || project.projectStatus===projectStatusCodeMap["ACTIVE"]
          || project.projectStatus===projectStatusCodeMap["CLOSED"] || (project.projectStatus===projectStatusCodeMap["DEVELOPMENT"] && t.dataIndex!=='formName'))}
          dataSource={quickFilterAssets ==='STATION' ? stationAssets.sort(multipleSort([iPSComp, assetNameComp])) : quickFilterAssets ==='P&C' ? pceAssets.sort(multipleSort([iPSComp, assetNameComp])) : assets.sort(multipleSort([iPSComp, assetNameComp]))}
          onChange={handleChange}
          loading={refreshAssets || refresh}
          pagination={{ showSizeChanger: false, pageSize: 10 }}
        
          scroll={{ x: 'max-content'}}   

          />
          { openModal &&
            <AttestationDialog
            show={openModal}
            handleCancel={handleCancel}
            attestationData={attestAsset}
          />
          }
    </div>
  );
}

export default Asset;